export default from './DailyStats.jsx';



// WEBPACK FOOTER //
// ./src/pages/daily_stats/index.js